import { render, staticRenderFns } from "./DisbursementInputTypeDate.vue?vue&type=template&id=15f1a6ac&"
import script from "./DisbursementInputTypeDate.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QPopupProxy,QDate,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon,QPopupProxy,QDate})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
